module.exports = __webpack_public_path__ + "static/media/project_4.25e10920.webp";